module.exports = __webpack_public_path__ + "img/weibo_logo.acf83034.png";